import { EntityId } from "@jackfruit/common"
import { ActionCreatorWithPayload, PayloadAction } from "@reduxjs/toolkit"
import { VNZImageEntity } from "~/interfaces/entities/VNZImage"
import { createEntitySlice } from "../createEntitySlice"

export interface LoadThumbnailForImagePayload {
  id: EntityId
}

export interface LoadFullImageForImagePayload {
  id: EntityId
}

interface VNZImagesActions {
  setCount: ActionCreatorWithPayload<number>
  setCurrentPage: ActionCreatorWithPayload<number>
  loadThumbnailForImage: ActionCreatorWithPayload<LoadThumbnailForImagePayload>
  loadFullImageForImage: ActionCreatorWithPayload<LoadFullImageForImagePayload>
}

const { slice, selectors: vnzImagesSelectors } =
  createEntitySlice<VNZImageEntity>(
    "VNZImages",
    {},
    {
      count: 0,
      currentPage: 0,
    },
    {
      setCount(state, action: PayloadAction<number>) {
        state.count = action.payload
      },
      setCurrentPage(state, action: PayloadAction<number>) {
        state.currentPage = action.payload
      },
      loadThumbnailForImage(
        state,
        action: PayloadAction<LoadThumbnailForImagePayload>
      ) {},

      loadFullImageForImage(
        state,
        action: PayloadAction<LoadFullImageForImagePayload>
      ) {},
    }
  )

const vnzImages = {
  ...slice,
  actions: slice.actions as typeof slice.actions & VNZImagesActions,
}

export { vnzImages, vnzImagesSelectors }
